import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nodes: [],
};

export const ftSlices = createSlice({
  name: "familytree",
  initialState,
  reducers: {
    addNode: (state, action) => {
      state.nodes.push(action.payload);
    },
    updateNode: (state, action) => {
      let { type, newObj, currentNodeId } = action.payload;
      let { nodes } = state;
      let rootNode;
      for (let i = 0; i < nodes.length; i++) {
        const element = nodes[i];
        if (element.id === currentNodeId) {
          rootNode = element;
        }
      }
      if (type === "addpartner") {
        for (let i = 0; i < nodes.length; i++) {
          const element = nodes[i];
          if (rootNode.id === element.id) {
            if (element.pids?.length > 0) {
              element.pids = [...element?.pids, newObj.id];
            } else {
              element.pids = [newObj.id];
            }
            if (newObj.relationship?.includes("Ex")) {
              if (element.divorced?.length > 0) {
                element.divorced = [...element?.divorced, newObj.id];
              } else {
                element.divorced = [newObj.id];
              }
            }
          }
        }
      } else if (type === "addparent") {
        if (newObj.gender === "female") {
          rootNode.mid = newObj.id;

          for (let i = 0; i < rootNode?.sids?.length; i++) {
            const outerElement = rootNode?.sids[i];
            for (let j = 0; j < nodes?.length; j++) {
              const innerElement = nodes[j];
              if (outerElement === innerElement.id) {
                innerElement.mid = newObj.id;
              }
            }
          }

          let father;
          if (rootNode.fid !== undefined) {
            for (let i = 0; i < nodes.length; i++) {
              const element = nodes[i];
              if (
                element.relationship === "Brother" ||
                element.relationship === "Sister"
              ) {
                element.mid = newObj.id;
                element.fid = rootNode.fid;
              }
              if (element.id === rootNode.fid) {
                father = element;
                if (element?.pids?.length > 0) {
                  element.pids = [...element?.pids, newObj.id];
                } else {
                  element.pids = [newObj.id];
                }
              }
              if (element.id === newObj.id) {
                if (element?.pids?.length > 0) {
                  element.pids = [...element?.pids, father.id];
                } else {
                  element.pids = [father.id];
                }
              }
            }
          }
        } else {
          rootNode.fid = newObj.id;
          for (let i = 0; i < rootNode?.sids?.length; i++) {
            const outerElement = rootNode?.sids[i];
            for (let j = 0; j < nodes?.length; j++) {
              const innerElement = nodes[j];
              if (outerElement === innerElement.id) {
                innerElement.fid = newObj.id;
              }
            }
          }

          let mother;
          if (rootNode.mid !== undefined) {
            for (let i = 0; i < state.nodes.length; i++) {
              const element = state.nodes[i];
              if (
                element.relationship === "Brother" ||
                element.relationship === "Sister"
              ) {
                element.fid = newObj.id;
                element.mid = rootNode.mid;
              }
              if (element.id === rootNode.mid) {
                mother = element;
                if (element?.pids?.length > 0) {
                  element.pids = [...element.pids, newObj.id];
                } else {
                  element.pids = [newObj.id];
                }
              }
              if (element.id === newObj.id) {
                if (element?.pids?.length > 0) {
                  element.pids = [...element.pids, mother.id];
                } else {
                  element.pids = [mother.id];
                }
              }
            }
          }
        }
      } else if (type === "childrelation") {
        if (rootNode.pids !== undefined) {
        }
      } else if (type === "addsiblings") {
        if (rootNode?.mid !== undefined && rootNode?.fid !== undefined) {
          for (let i = 0; i < nodes.length; i++) {
            const element = nodes[i];
            if (element.id === newObj.id) {
              element.mid = rootNode.mid;
              element.fid = rootNode.fid;
            }
          }
          if (rootNode.sids?.length > 0) {
            rootNode.sids = [...rootNode.sids, newObj.id];
          } else {
            rootNode.sids = [newObj.id];
          }
        } else if (rootNode?.fid !== undefined) {
          for (let i = 0; i < nodes.length; i++) {
            const element = nodes[i];

            if (rootNode.mid !== undefined) {
              element.mid = rootNode.mid;
            }
            if (element.id === newObj.id) {
              element.fid = rootNode.fid;
            }
          }
          if (rootNode.sids?.length > 0) {
            rootNode.sids = [...rootNode.sids, newObj.id];
          } else {
            rootNode.sids = [newObj.id];
          }
        } else if (rootNode?.mid !== undefined) {
          for (let i = 0; i < nodes.length; i++) {
            const element = nodes[i];

            if (rootNode.mid !== undefined) {
              element.mid = rootNode.mid;
            }
            if (element.id === newObj.id) {
              element.mid = rootNode.mid;
            }
          }
          if (rootNode.sids?.length > 0) {
            rootNode.sids = [...rootNode.sids, newObj.id];
          } else {
            rootNode.sids = [newObj.id];
          }
        } else {
          if (rootNode.sids?.length > 0) {
            rootNode.sids = [...rootNode.sids, newObj.id];
          } else {
            rootNode.sids = [newObj.id];
          }
        }
      }
    },
    updateNodeOnEdit: (state, action) => {
      let { nodes } = state;
      let {
        nodeId,
        firstName,
        lastName,
        address,
        personPassedAway,
        personLives,
        dateOfBirth,
        complicatedRelation,
      } = action.payload;
      for (let i = 0; i < nodes.length; i++) {
        let element = nodes[i];
        if (element.id === nodeId) {
          element.firstName = firstName;
          element.lastName = lastName;
          element.address = address;
          element.isAlive = personPassedAway;
          element.personLives = personLives;
          element.dateOfBirth = dateOfBirth;
          element.complicatedRelation = complicatedRelation;
          if (personPassedAway) {
            element.isAliveImage = "/assets/icons/cross.png";
          } else {
            delete element.isAliveImage;
          }
        }
      }
    },
  },
});

export const { addNode, updateNode, updateNodeOnEdit } = ftSlices.actions;

export default ftSlices.reducer;
